import AlertPage from "components/common/AlertPage";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Alert } from "react-ionicons";
import { useLocation } from "react-router-dom";
import axios from "axios";
import axiosInstance from "services/axiosInstance";


const CommandConfiramtion = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const processPayment = async () => {
      // Récupérer l'idop depuis l'URL
      const urlParams = new URLSearchParams(location.search);
      const idop = urlParams.get('idop');

      if (!idop) {
        setError("Identifiant de paiement manquant");
        setIsLoading(false);
        return;
      }

      try {
        // 1. D'abord, déclencher la notification PayFiP
        // On appelle directement l'URL de notification backend avec l'idop
        const notificationUrl = `${process.env.REACT_APP_API_BASE_URL || 'https://varras.mbscom.net'}/paiement-front/payfipws/notification`;
        
        // Appel de notification PayFiP (fire and forget)
        axios.post(notificationUrl, `idop=${idop}`, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).catch(err => {
          console.log("Notification PayFiP envoyée (erreur ignorée si déjà traitée)", err);
        });

        // 2. Attendre un peu pour laisser le temps au backend de traiter
        await new Promise(resolve => setTimeout(resolve, 2000));

        // 3. Vérifier le statut du paiement
        const statusResponse = await axiosInstance.post(
          '/payment/payfip/status',
          `idop=${idop}`,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );

        setPaymentStatus(statusResponse.data);
        
      } catch (err) {
        console.error("Erreur lors du traitement du paiement:", err);
        setError("Une erreur est survenue lors du traitement de votre paiement");
      } finally {
        setIsLoading(false);
      }
    };

    processPayment();
  }, [location.search]);

  // Affichage pendant le chargement
  if (isLoading) {
    return (
      <div className="page-content">
        <Helmet>
          <title>Traitement du paiement en cours...</title>
        </Helmet>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Chargement...</span>
          </div>
          <h2 style={{ marginTop: '20px' }}>Traitement de votre paiement en cours...</h2>
          <p>Veuillez patienter quelques instants</p>
        </div>
      </div>
    );
  }

  // Affichage en cas d'erreur
  if (error) {
    return (
      <div className="page-content">
        <Helmet>
          <title>Erreur de paiement</title>
        </Helmet>
        <AlertPage 
          title="Erreur de paiement" 
          description={error}
          type="error"
        />
      </div>
    );
  }

  // Affichage en fonction du statut du paiement
  if (paymentStatus) {
    const isSuccess = paymentStatus.statut === 'P';
    
    return (
      <div className="page-content">
        <Helmet>
          <title>{isSuccess ? "Merci pour votre commande" : "Paiement échoué"}</title>
          <meta name="description" content={paymentStatus.message} />
        </Helmet>
        <AlertPage 
          title={isSuccess ? "Merci pour votre commande" : "Paiement échoué"}
          description={
            isSuccess 
              ? "Nous avons bien reçu votre commande. Un email récapitulatif avec vos billets vient de vous être adressé à l'adresse renseignée."
              : paymentStatus.message || "Le paiement n'a pas pu être finalisé. Veuillez réessayer."
          }
          type={isSuccess ? "success" : "error"}
        />
        {isSuccess && paymentStatus.commande && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <p>Numéro de commande : <strong>{paymentStatus.commande.id}</strong></p>
            <p>Montant : <strong>{paymentStatus.commande.montant} €</strong></p>
          </div>
        )}
      </div>
    );
  }

  // Cas par défaut
  return (
    <div className="page-content">
      <Helmet>
        <title>Traitement du paiement</title>
      </Helmet>
      <AlertPage 
        title="Traitement du paiement" 
        description="Votre paiement est en cours de traitement..."
      />
    </div>
  );
};

export default CommandConfiramtion;
